/* global notyf */
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['accountantForm', 'selfServiceForm'];

  connect() {
    const isNewPage = document.querySelector('.new-company-wrapper');
    if (isNewPage) {
      const newCompanyTab = document.querySelector('li.bookmark-foundation');
      newCompanyTab.classList.add('bookmark-new-page');
    }

    const CONTENT_TYPE = { jdg: 'jdg', spzoo: 'spzoo' };
    let activeContent = CONTENT_TYPE.jdg;

    const switchContentJdg = document.querySelector('#x-switch-content-jdg');
    const switchContentSpzoo = document.querySelector('#x-switch-content-spzoo');
    switchContentJdg?.addEventListener('click', () => {
      if (activeContent === CONTENT_TYPE.jdg) return;
      const jdgContent = document.querySelector('#new-company-jdg');
      const spzooContent = document.querySelector('#new-company-spzoo');
      jdgContent.style.display = 'block';
      spzooContent.style.display = 'none';
      activeContent = CONTENT_TYPE.jdg;
    });
    switchContentSpzoo?.addEventListener('click', () => {
      if (activeContent === CONTENT_TYPE.spzoo) return;
      const jdgContent = document.querySelector('#new-company-jdg');
      const spzooContent = document.querySelector('#new-company-spzoo');
      jdgContent.style.display = 'none';
      spzooContent.style.display = 'block';
      activeContent = CONTENT_TYPE.spzoo;
    });
  }

  selectPath = (event) => {
    const selfService = event.target.value === 'self_service';

    this.accountantFormTarget.classList.toggle('hidden', selfService);
    this.selfServiceFormTarget.classList.toggle('hidden', !selfService);
  };

  removeValidationErrorClass = (event) => {
    event.target.parentElement.classList.remove('validation-error');
  };

  showWebviewRestrictionMessage = (event) => {
    event.preventDefault();
    notyf.open({
      type: 'warning',
      message: 'Funkcjonalność dostępna tylko w przeglądarce',
      duration: 3000,
    });
  };
}
